module.exports = __webpack_public_path__ + "static/media/shentao.2ca0e153.png";